import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { choice_array, choices, formArrayItem } from '../preview-forms.interface';
import { getUploadsBaseURL } from 'src/app/app.url';
import { resolveMediaUrl } from 'src/app/shareds/utils/media-url.util';
import { isChoiceFull } from 'src/app/shareds/utils/quota.util';


@Component({
    selector: 'app-form-signle',
    templateUrl: './form-signle.component.html',
    styleUrls: ['./form-signle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormSignleComponent {
  value: string = ""
  /** ข้อความที่ผู้ตอบพิมพ์ในตัวเลือก "อื่น ๆ (ระบุ)" */
  otherText: string = ""
  form!: formArrayItem;
  @Input('model') set item(v: formArrayItem) {
    this.form = v;
    if (this.form?.choices_value) this.setValue();
  }

  @Output('update') update = new EventEmitter()
  @Output('valid') valid = new EventEmitter()

  trackByIndex(index: number): number { return index; }

  private uploadsBaseURL: string = getUploadsBaseURL();
  /** แปลง path รูปภาพประกอบตัวเลือก (คำถามแบบเทียบรูป) เป็น URL ที่โหลดได้จริง */
  resolveChoiceMediaUrl(path?: string | null): string | null {
    return resolveMediaUrl(this.uploadsBaseURL, path);
  }

  setValue() {
    this.value = this.form?.choices_value[0]?.question_choice_id
    this.otherText = this.form?.choices_value[0]?.choice_value ?? ""
  }

  /** ตัวเลือกที่เลือกอยู่เป็น "อื่น ๆ (ระบุ)" หรือไม่ */
  get selectedIsOther(): boolean {
    return (this.form?.choices || []).some((c: choices) => c.question_choice_id === this.value && c.is_other_option === true)
  }

  private emit() {
    const item: choice_array = { question_choice_id: this.value }
    if (this.selectedIsOther) item.choice_value = this.otherText
    this.update.emit([item])
    if (this.value) this.valid.emit(false)
  }

  updateValue(v: any) {
    this.value = v.value
    this.emit()
  }

  selectChoice(sm: any) {
    if (this.form?.view) return
    // เต็มแล้ว = เลือกไม่ได้ ยกเว้นเป็นค่าที่เลือกอยู่แล้ว (กันเปลี่ยนใจแล้วเอาออกไม่ได้) — บังคับจริงอยู่ที่ backend เสมอ
    if (isChoiceFull(sm) && sm.question_choice_id !== this.value) return
    this.value = sm.question_choice_id
    if (!this.selectedIsOther) this.otherText = ""
    this.emit()
  }

  isChoiceFull(sm: any): boolean {
    return isChoiceFull(sm) && sm.question_choice_id !== this.value
  }

  onOtherText() {
    if (this.form?.view) return
    this.emit()
  }

  updateValiDate(e: any) {
    this.valid.emit(e)
  }


}
